/* Country flag + dial code picker for every phone field (intl-tel-input from jsDelivr). */
(function () {
  var V = '24.5.0';
  var BASE = 'https://cdn.jsdelivr.net/npm/intl-tel-input@' + V + '/build/';
  function css(href) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; document.head.appendChild(l); }
  function init() {
    if (!window.intlTelInput) return;
    document.querySelectorAll('input[type="tel"]:not([data-iti])').forEach(function (inp) {
      inp.setAttribute('data-iti', '1');
      inp.removeAttribute('pattern');
      var wrap = inp.closest('.input-style-1');
      if (wrap) wrap.classList.add('has-iti');
      var label = wrap && wrap.querySelector('.form-label');
      if (label && !inp.placeholder) inp.setAttribute('placeholder', ' ');
      var iti = window.intlTelInput(inp, {
        initialCountry: 'us',
        countryOrder: ['us', 'ca', 'gb', 'au'],
        separateDialCode: true,
        loadUtils: function () { return import(BASE + 'js/utils.js'); }
      });
      var form = inp.closest('form');
      if (form) form.addEventListener('submit', function () {
        var v = inp.value.trim();
        if (v && v.charAt(0) !== '+') inp.value = '+' + iti.getSelectedCountryData().dialCode + ' ' + v;
      });
    });
  }
  function load() {
    css(BASE + 'css/intlTelInput.css');
    var s = document.createElement('script');
    s.src = BASE + 'js/intlTelInput.min.js';
    s.onload = init;
    document.head.appendChild(s);
  }
  function start() {
    if (!document.querySelector('input[type="tel"]')) {
      new MutationObserver(function (m, o) {
        if (document.querySelector('input[type="tel"]')) { o.disconnect(); load(); }
      }).observe(document.documentElement, { childList: true, subtree: true });
      return;
    }
    load();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
